import React, { useEffect, useRef, useState } from 'react'
import { downloadRhImportTemplate } from '../../api/index'
import styles from './RhTemplateMenu.module.css'
import btnStyles from '../ImportMensuel/ImportMensuel.module.css'

const extractFilename = (contentDisposition, fallback) => {
  const match = contentDisposition?.match(/filename="([^"]+)"/)
  return match?.[1] || fallback
}

const FALLBACK_FILENAMES = {
  sage: 'modele-import-sage-coaches.xlsx',
  regime: 'modele-import-regime-coaches.xlsx',
}

const getDownloadErrorMessage = async (error) => {
  const blob = error?.response?.data
  if (blob instanceof Blob) {
    try {
      const parsed = JSON.parse(await blob.text())
      if (parsed?.message) return parsed.message
    } catch {
      // ignore parse errors
    }
  }
  return error?.response?.data?.message
    || (error?.response?.status === 404
      ? 'Modèle indisponible pour cette période'
      : 'Erreur téléchargement du modèle Excel')
}

const RhTemplateMenu = ({ onError, onSuccess, className = '' }) => {
  const [open, setOpen] = useState(false)
  const [downloading, setDownloading] = useState(false)
  const menuRef = useRef(null)

  useEffect(() => {
    if (!open) return undefined

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open])

  const handleDownload = async (type) => {
    setDownloading(true)
    setOpen(false)

    try {
      const response = await downloadRhImportTemplate({ type })

      const filename = extractFilename(
        response.headers['content-disposition'],
        FALLBACK_FILENAMES[type]
      )
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      link.click()
      window.URL.revokeObjectURL(url)
      onSuccess?.(type)
    } catch (error) {
      onError?.(await getDownloadErrorMessage(error))
    } finally {
      setDownloading(false)
    }
  }

  return (
    <div className={`${styles.menu} ${className}`} ref={menuRef}>
      <button
        type="button"
        className={`${btnStyles.secondaryBtn} ${styles.trigger}`}
        onClick={() => setOpen((value) => !value)}
        disabled={downloading}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        {downloading ? 'Téléchargement…' : 'Modèle Excel RH'}
        <span className={styles.chevron} aria-hidden="true">▾</span>
      </button>

      {open && (
        <div className={styles.dropdown} role="menu">
          <button
            type="button"
            className={styles.option}
            role="menuitem"
            disabled={downloading}
            onClick={() => handleDownload('sage')}
          >
            <span className={styles.optionTitle}>
              Auto-entrepreneurs (export Sage)
              <span className={styles.recommended}>Recommandé</span>
            </span>
            <span className={styles.optionHint}>
              Matricule Sage, Prénom, Nom, Net à payer — honoraires + 1 TND de timbre (pas de TVA ni retenue).
            </span>
          </button>
          <button
            type="button"
            className={styles.option}
            role="menuitem"
            disabled={downloading}
            onClick={() => handleDownload('regime')}
          >
            <span className={styles.optionTitle}>Régime réel / forfaitaire</span>
            <span className={styles.optionHint}>
              Même format Sage. Montant = honoraires HT → TVA 19 %, retenue 3 % (réel) ou 1 % (forfaitaire), + 1 TND timbre.
            </span>
          </button>
        </div>
      )}
    </div>
  )
}

export default RhTemplateMenu
